import { Button } from "primereact/button";
import React from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  BUSINESS_LINE_COLORS,
  BUSINESS_LINE_PATHS,
} from "../../../helpers/utils";

function SadadPay({ i18n, ackAgree, loading, sadadHandler }) {
  const { businessLine } = useSelector((state) => state.travel);

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.STC)
    businessColor = BUSINESS_LINE_COLORS.STC;
  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center w-100"
      style={{ minHeight: "300px" }}
    >
      <h4 className="mb-3">{i18n.t("common.sadad_question")}</h4>
      <div className="btn-group">
        <Button
          loading={loading}
          className="btn primary mb-3"
          onClick={() => sadadHandler()}
          disabled={!ackAgree}
          style={{ background: businessColor }}
        >
          {i18n.t("CONFIRM")}
        </Button>
      </div>
      <p>{i18n.t("common.sadad_quote")}</p>
    </div>
  );
}

export default withTranslation()(SadadPay);
